<template>
	<div class="col-xl-7">
		<div class="card">
			<div
				v-if="jsonEvaluacionAlumno.preguntasRespondidas > 0"
				class="card-body"
			>
			<div v-if="!loadTabla">
				<h5 class="header-title mb-4">
					<router-link
						:to="
							'/info-evaluacion/' +
								jsonEvaluacionAlumno.idEvaluacion
						"
					>
						# {{ jsonEvaluacionAlumno.idEvaluacion }}
						{{ jsonEvaluacionAlumno.nombreEvaluacion }}
					</router-link>
				</h5>
				<p class="card-title-desc">
					A continuación, verás las preguntas desplegadas al alumno
					para esta evaluación con sus respectivas respuestas.
				</p>

				<div v-for="(preguntaAlumno,indexPreguntaAlumno) in jsonEvaluacionAlumno.respuestaAlumno" :key="preguntaAlumno.idRe">
					<div v-for="(pregunta, indexPregunta) in infoEvaluacion" :key="indexPregunta">
						<b-container v-if="preguntaAlumno.idPregunta === pregunta.idPregunta">
							<b-row class="col-md-12 divPregunta">
								{{ indexPreguntaAlumno + 1 }}.-
								<span v-html="pregunta.nombrePregunta"></span>
							</b-row>
							<b-row class="divRespuesta col-xl-12">
								<div class="col-xl-12" v-for="(respuesta, indexRespuesta) in pregunta.respuestas" :key="indexRespuesta">
									<div
										v-for="(respuestaAlumno,
										indexAlumno) in jsonEvaluacionAlumno.respuestaAlumno"
										:key="indexAlumno"
									>
										<div
											v-if="
												respuestaAlumno.idPregunta ==
													respuesta.idPregunta
											"
										>
											<div
												v-if="
													respuestaAlumno.idRespuesta ==
														respuesta.idRespuesta
												"
											>
												<input
													@change="
														cambioCheck(
															$event,
															respuestaAlumno.idRe,
															respuesta.idRespuesta
														)
													"
													type="radio"
													:name="
														respuestaAlumno.idPregunta
													"
													checked
												/>
												<span
													v-if="
														respuesta.correcta == 1
													"
													class="right-answer"
												>
													{{
														respuesta.textoRespuesta
													}}
												</span>
												<span v-else>
													{{
														respuesta.textoRespuesta
													}}
													<i
														class="fas fa-times"
														style="color:red"
													></i
												></span>
											</div>
											<div v-else>
												<input
													@change="
														cambioCheck(
															$event,
															respuestaAlumno.idRe,
															respuesta.idRespuesta,
															pregunta.idPregunta
														)
													"
													type="radio"
													:name="
														respuestaAlumno.idPregunta
													"
												/>
												<span
													v-if="
														respuesta.correcta == 1
													"
													class="right-answer"
												>
													{{
														respuesta.textoRespuesta
													}}
												</span>
												<span v-else>
													{{
														respuesta.textoRespuesta
													}}</span
												>
											</div>
										</div>
									</div>
								</div>
								<div>
									<br />
									<p class="right-answer">
										<b>Argumento:</b>
										{{ pregunta.argumento }}.
									</p>
									<b> Pregunta N° </b
									><strong style="color:orange"
										>({{ pregunta.idPregunta }})
									</strong>
								</div>
							</b-row>
						</b-container>
					</div>
				</div>
			</div>
			<div v-else class="card-body">
				<b-alert :show="showDismissibleAlert" fade variant="danger">
					El alumno {{ infoAlumno.numeroDocumento }} -
					{{ infoAlumno.nombre }} {{ infoAlumno.apellido }} aún no
					comienza su evaluación.
				</b-alert>
			</div>
			</div>
			<div v-else class="card-body">
				<b-alert :show="showDismissibleAlert" fade variant="danger">
					El alumno {{ infoAlumno.nombre }} {{ infoAlumno.apellido }} aún no
					comienza su evaluación.
				</b-alert>
			</div>
			<!-- <PuSkeleton class="card-body" v-else :count="6"></PuSkeleton> -->
		</div>
		
		<toastComponent ref="toastComponent" />
		<fechaComponent ref="fechaComponent" />
		<modalConfirmar v-if="booleanModal" @clicked="sendRespuesta"/>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import toastComponent from "@/components/toastComponent";
import fechaComponent from "@/components/fechaConversionComponent";
import modalConfirmar from "../evaluacion-alumno/modal/modalConfirmar.vue";
import $ from "jquery";

export default {
	components: {
		fechaComponent,
		toastComponent,
		modalConfirmar
	},
	data() {
		return {
			infoEvaluacion: "",
			infoAlumno: "",
			evAlumno: "",
			showDismissibleAlert: false,
			loadTabla: "",
			booleanModal:false,
			evento:null,
			currentidResultadoEvaluacion:null,
			currentidRespuesta:null,
			currentidPregunta:null
		};
	},
	computed: {
		...mapState("evaluacionAlumno", ["jsonEvaluacionAlumno"]),
		...mapState("alumno", ["jsonCoordinadora"]),
	},
	methods: {
		...mapActions("evaluacionAlumno", ["updateEvaluacionAlumno"]),
		...mapActions("evaluacionAlumno", ["updateRespuestasCorrecta"]),
		...mapActions("evaluacionAlumno", ["updateRespuestasIncorrecta"]),
		...mapActions("evaluacion", ["updateEstadoNota"]),
		...mapActions("alumno", ["updateJsonCoordinadora"]),
		...mapActions("alumno", ["updateRecalculoNota"]),
		sendRespuesta(boolean){
			if(boolean){
				this.cambiarRespuestaMethod();
			}else{
                const arrayToast = {
					msg: `No se han aplicado cambios.`,
					title: `Sin cambios`,
					variant: `danger`,
				};
				this.$refs.toastComponent.makeToast(arrayToast);
				this.getEvaluacionAlumno(this.idEvaluacion, this.idAlumno);
			}
            this.evento.target.checked = boolean;
		    this.booleanModal = false;
		},
		cambioCheck(event,idResultadoEvaluacion, idRespuesta,idPregunta){
			event.preventDefault();
            this.evento = event;
			this.currentidResultadoEvaluacion = idResultadoEvaluacion;
			this.currentidRespuesta = idRespuesta;
			this.idPregunta = idPregunta;
			this.booleanModal = true;
		},
		async cambiarRespuestaMethod(){
            const { data } = await this.axios.put(
				"api/updateResultadoAlumno/" +
					this.idEvaluacion +
					"/" +
					this.idAlumno +
					"/" +
					this.currentidResultadoEvaluacion +
					"/" +
					this.currentidRespuesta
			);
			const {} = data;
			this.updateEvaluacion(this.currentidPregunta);
		},
		async updateEvaluacion(idPregunta) {
			const form = {
				idNota: this.jsonEvaluacionAlumno.idNota,
				idAlumno: this.infoAlumno.idAlumno,
				idEvaluacion: this.idEvaluacion,
				idLogeado:JSON.parse(window.atob(localStorage.getItem('usuarioDB'))).idAlumno
			};
			const data = await this.axios.post("api/recalculoNota", form);

			if (data.data.msg == "notaActualizada") {
				this.jsonEvaluacionAlumno.notafinal = data.data.nuevaNota;
				//contar las correctas
				let contadorBuenas = 0;
				let contadorMalas = 0;
				if(data.data.controlByAlumno != undefined){
					data.data.controlByAlumno.map((pregunta)=>{
                        if(pregunta.correcta == null){
                            contadorMalas += 1;
						}else{
							contadorBuenas += 1;
						}
					});
				}

				this.jsonEvaluacionAlumno.respuestasCorrectas = contadorBuenas;
				this.jsonEvaluacionAlumno.respuestasIncorrectas = contadorMalas;
				const arrayToast = {
					msg: `Se ha cambiado la respuesta en la pregunta #${idPregunta} y se ha actualizado la nota a: ${this.precise_round(data.data.nuevaNota,1)}`,
					title: `Exito en el cambio nota`,
					variant: `success`,
				};
				this.$refs.toastComponent.makeToast(arrayToast);
				this.updateEstadoNota(true);
			}
		},
		precise_round(num, decimals) {
			var t = Math.pow(10, decimals);
			return (
				Math.round(
					num * t +
						(decimals > 0 ? 1 : 0) *
							(Math.sign(num) * (10 / Math.pow(100, decimals)))
				) / t
			).toFixed(decimals);
		},
		async getEvaluacionAlumno(idEvaluacion, idAlumno) {
			this.loadTabla = true;

			const { data } = await this.axios.get(
				"api/getEvaluacionAlumno/" + idEvaluacion + "/" + idAlumno
			);

			const {
				error,
				ok,
				getNotaFinal,
				fechaHabilitacion,
				fechaCierre,
				nombreEvaluacion,
				preguntasRespondidas,
				totalPregunta,
				respuestasCorrectas,
				respuestasIncorrectas,
				getRespuestaAlumno,
			} = data;

			if (!ok) {
				let arrayToast = {
					msg: `${error}. Redireccionando...`,
					title: "Error",
					variant: "danger",
				};
				this.$refs.toastComponent.makeToast(arrayToast);

				setTimeout(
					() =>
						this.$router.push({
							path: "/evaluacion-curso",
						}),
					5000
				);
				return false;
			}

			this.evAlumno = {
				idEvaluacion: getNotaFinal.idEvaluacion,
				fechaHabilitacion: this.fecha(fechaHabilitacion),
				fechaCierre: this.fecha(fechaCierre),
				nombreEvaluacion,
				preguntasRespondidas,
				totalPregunta,
				respuestasCorrectas,
				respuestasIncorrectas,
				idNota: getNotaFinal.idNota,
				notafinal: getNotaFinal.nota,
				respuestaAlumno: getRespuestaAlumno,
			};

			this.updateEvaluacionAlumno(this.evAlumno);

			if (this.jsonEvaluacionAlumno.preguntasRespondidas == 0) {
				this.showDismissibleAlert = true;
			}

			this.loadTabla = false;
		},
		async getInfoEvaluacion(idEvaluacion) {
			const evaluacion = (await this.axios.get("api/getEvaluacion/" + idEvaluacion)).data;
			this.infoEvaluacion = evaluacion.getPreguntaTotal;
			// //logica privilegios
			const user = (await this.axios.get("api/getLoginLogeado")).data.usuarioDB;
			const privilegiosCoordinadora = (await this.axios.get(`api/getCoordinadoraCampus`)).data.getPrivilegios;
			this.updateJsonCoordinadora({...user,privilegios: privilegiosCoordinadora});

			let ArrayCoordinadora = [];
			Object.entries(privilegiosCoordinadora).forEach(([key, value]) => {
				ArrayCoordinadora.push({key, value});
			});
 
			const programaCoordinadora = (ArrayCoordinadora.find(obj => obj.value.idPrograma = evaluacion.evaluacion.idPrograma)).value;
			const recalculoNota = programaCoordinadora.recalculoNota === 1 ? true : false;

			this.updateRecalculoNota(recalculoNota);
			//fin logica privilegios

			/* 	const { privilegios } = this.jsonCoordinadora;
			const programaCoordinadora = privilegios.find(p=> p.idPrograma === curso.idPrograma); */

			//const inscripcionAlumnos = programaCoordinadora.inscripcionAlumno === 1 ? true : false;
		},
		async getResultadoAlumno() {
			const parametros = {
				idNota: this.evAlumno.idNota,
				idEvaluacion: this.idEvaluacion,
				idAlumno: this.idAlumno,
			};
			const { data } = await this.axios.get(
				"api/getResultadoNota/" +
					parametros.idNota +
					"/" +
					parametros.idEvaluacion +
					"/" +
					parametros.idAlumno
			);
			const { estadoNota } = data;
			this.updateEstadoNota(estadoNota);
		},
		fecha(fechaCurso) {
			return fechaCurso
				? this.$refs.fechaComponent.fechaFinal(fechaCurso)
				: "-";
		},
		getInfoAlumno(idAlumno) {
			this.axios.get("api/getIdAlumno/" + idAlumno).then(res => {
					this.infoAlumno = res.data.alumno;
			}).catch(err => console.log(err));
		},
	},
	created() {
		this.idEvaluacion = this.$route.params.idEvaluacion;
		this.idAlumno = this.$route.params.idAlumno;
		this.getEvaluacionAlumno(this.idEvaluacion, this.idAlumno);
		this.getInfoEvaluacion(this.idEvaluacion);
		this.getInfoAlumno(this.idAlumno);
	},
	updated() {
		this.evAlumno.idNota ? this.getResultadoAlumno() : null;
	},
};
</script>
<style scoped>
.right-answer {
	background-color: #e6f5d4;
	border: 0 none;
}
.divRespuesta {
	background-color: #f5f5f5;
	margin-top: 10px;
	border-radius: 8px;
	padding: 15px 20px 20px;
	margin-bottom: 20px;
}
.divPregunta {
	background-color: #1c3947;
	overflow: auto;
	border-radius: 7px;
	color: white;
	padding-top: 10px;
	padding-left: 20px;
	padding-right: 20px;
}
.right-answer {
	background-color: #e6f5d4;
	border: 0 none;
}
</style>
